import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class APDEmployeeGroup  {
    _originalTypeClassName = "zERP.BO.APDEmployeeGroup";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
APDEmployeeGroup.translate = translateService;
}
this.Contributions = [];
this.Key = null;
this.InsuranceProfessionCode = null;
this.SpecialInsuranceCase = null;
this.InsuranceCoveragePackage = null;
this.Month = null;
this.Year = null;
this.SalaryTypeCode = null;
this.SICCode = null;
this.APDEmployeeGroupKey = null;
this._key = this.APDEmployeeGroupKey = 0; 
}

static translate: TranslateService;
_key: any;
Key:any;
InsuranceProfessionCode:any;
SpecialInsuranceCase:any;
InsuranceCoveragePackage:any;
Month:any;
Year:any;
SalaryTypeCode:any;
SICCode:any;
Contributions:any;
EmployeePayroll:any;
private _APDEmployeeGroupKey:any;
get APDEmployeeGroupKey(): any {
    return this._APDEmployeeGroupKey;
  }
set APDEmployeeGroupKey(value: any) {
    this._APDEmployeeGroupKey = value;
    this._key = value;
  }
static setContributions = ($this, items) => {
                if (items == null) items = [];
                if ($this.Contributions == null) $this.Contributions = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Contributions.length > 0) {
                    Domain.APDEmployeeGroup.removeContributions($this, $this.Contributions[0]);
                }

                Domain.APDEmployeeGroup.addManyContributions($this, copyItems);
            }
static addManyContributions = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.APDEmployeeGroup.addContributions($this, items[i]);
                }
            }
static addContributions = ($this, item) => {
                if ($this.Contributions == null) $this.Contributions = [];
                if (item == null || $this.Contributions.indexOf(item) > -1) return;
                $this.Contributions.push(item);
}
static addRangeContributions = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.APDEmployeeGroup.addContributions($this, item));
            }
static removeContributions = ($this, item) => {
                if ($this == null || $this.Contributions == null || $this.Contributions.indexOf(item) === -1) return;
                var _index = $this.Contributions.indexOf(item);
                $this.Contributions.splice(_index, 1);
}
static clearContributions = ($this) => { $this.Contributions = null; }
static setEmployeePayroll = ($this, value) => {
var oldValue = $this.EmployeePayroll;
$this.EmployeePayroll = value;
if (value != null) {
}
}

static GetGroupEmployeeAmount($this: any): any{return $this?.Contributions?.linq?.sum((l) => l?.EmployeeAmount);
}
static GetGroupEmployeeContribution($this: any): any{return $this?.Contributions?.linq?.sum((l) => l?.EmployeeContribution);
}
static GetGroupEmployeeSubsidy($this: any): any{return $this?.Contributions?.linq?.sum((l) => l?.EmployeeSubsidy);
}
static GetGroupEmployerContribution($this: any): any{return $this?.Contributions?.linq?.sum((l) => l?.EmployerContribution);
}
static GetGroupEmployerSubsidy($this: any): any{return $this?.Contributions?.linq?.sum((l) => l?.EmployerSubsidy);
}
static GetGroupEmployerSubsidyRate($this: any): any{return $this?.Contributions?.linq?.sum((l) => l?.EmployerSubsidyRate);
}
static GetKey(month: any,year: any,contribution: any,conDetail: any): any{let IPC = Domain.PayrollIntegration.PrepareNumber(contribution?.SICProfessionPackage?.InsuranceProfession?.Code, 6, true);
let SIC = (contribution?.SpecialInsuranceCase != null ? Domain.PayrollIntegration.PrepareNumber(contribution?.SpecialInsuranceCase?.Code, 2, true) : "00");
let ICP = Domain.PayrollIntegration.PrepareNumber(contribution?.SICProfessionPackage?.InsuranceCoveragePackage?.Code, 4, true);
let STC = Domain.PayrollIntegration.PrepareNumber(conDetail?.SalaryType?.Code, 3, true);
let RC = conDetail?.Rule?.Code;
let SC = Domain.PayrollIntegration.PrepareNumber(contribution?.SICProfessionPackage?.SIC?.Code, 4, true);
return month?.toString() + "_" + year?.toString() + "_" + STC + "_" + IPC + "_" + SIC + "_" + ICP + "_" + RC + "_" + SC;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.APDEmployeeGroupKey == null || $this.APDEmployeeGroupKey == 0;
            }


}